module.exports = __webpack_public_path__ + "img/Loading.4bcfb916.gif";